var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookSquareDarkBlue = function SvgFacebookSquareDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00586C",
    d: "M20.75 2H4.25A2.25 2.25 0 0 0 2 4.25v16.5A2.25 2.25 0 0 0 4.25 23h6.434v-7.14H7.73V12.5h2.954V9.939c0-2.914 1.734-4.523 4.39-4.523 1.273 0 2.603.227 2.603.227v2.86H16.21c-1.444 0-1.895.896-1.895 1.815V12.5h3.225l-.516 3.36h-2.709V23h6.434A2.25 2.25 0 0 0 23 20.75V4.25A2.25 2.25 0 0 0 20.75 2"
  })));
};
export default SvgFacebookSquareDarkBlue;